import { render, staticRenderFns } from "./DigitalFactorySolutions.vue?vue&type=template&id=97d9f348&scoped=true"
import script from "./DigitalFactorySolutions.vue?vue&type=script&lang=js"
export * from "./DigitalFactorySolutions.vue?vue&type=script&lang=js"
import style0 from "./DigitalFactorySolutions.vue?vue&type=style&index=0&id=97d9f348&prod&lang=scss&scoped=true"
import style1 from "./DigitalFactorySolutions.vue?vue&type=style&index=1&id=97d9f348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d9f348",
  null
  
)

export default component.exports